import Box from '@mui/material/Box';
import React from 'react';

import { SegmentTypes } from './hooks/useGetCycleSegments';

type IdleSegmentProps = {
  startPosition: string;
  endPosition: string;
  type: string;
  hasLogging: boolean;
};

const IdleSegment = ({
  startPosition,
  endPosition,
  type,
  hasLogging,
}: IdleSegmentProps) => {
  const topByType: Record<string, string> = {
    [SegmentTypes.PICK_UP]: '0%',
    [SegmentTypes.EN_ROUTE]: hasLogging ? '25%' : '33%',
    [SegmentTypes.DROP_OFF]: hasLogging ? '50%' : '66%',
    [SegmentTypes.LOGGING]: '75%',
  };

  const top = topByType[type];

  return top ? (
    <Box
      sx={{
        position: 'absolute',
        left: startPosition,
        right: endPosition,
        height: '16px',
        borderRadius: '2px',
        top: top,
        backgroundColor: '#FDE68A',
        transform: 'translateY(25%)',
      }}
    />
  ) : null;
};

export { IdleSegment };
